import { Button, Container, Paper, Stack, Text, Title } from '@mantine/core';
import { useSession } from '../../controllers/session-context.jsx';
import { ErrorNotice } from '../feedback/error-notice.jsx';
import { Loading } from '../feedback/loading.jsx';

export function ProtectedRoute({ children }) {
  const { user, loading, error, refreshUser } = useSession();
  if (loading) return <Loading label="Loading your account…" />;
  if (error) return <Container size="sm" py="xl"><ErrorNotice error={error} retry={refreshUser} /></Container>;
  if (!user) return <Container size="sm" py="xl"><Paper withBorder p="xl"><Stack><Title order={1}>Sign in to continue</Title><Text c="dimmed">Connect your Google account to explore your verified properties.</Text><Button component="a" href="/auth/google">Sign in with Google</Button></Stack></Paper></Container>;
  return children;
}
